import React from 'react'
import st from './ClientDuplicateCard.module.scss'
import { formatClientDate } from '../utils'
import useLocalization from 'hooks/useLocalization'

const ClientDuplicateCard = ({ duplicate, deal, onClick, isSelected }) => {
  const { translate } = useLocalization({
    section: 'groups',
    subsection: 'all_groups',
    dict: {
      client_profile: 'Client profile',
      name: 'Name',
      transaction: 'Transaction',
      date_of_creation: 'Date of creation',
    },
  })

  return (
    <div
      className={`${st.container} ${isSelected ? st.selected : ''}`}
      onClick={onClick}
    >
      <div className={st.clientProfile}>{translate?.client_profile}</div>
      <div className={st.data}>
        <div className={st.textSt}>
          <div className={st.copitalText}>{translate?.name}:</div>
          <div className={st.information}>{duplicate?.name}</div>
        </div>
        <div className={st.textSt}>
          <div className={st.copitalText}>{translate?.transaction}:</div>
          <div className={st.information}>#{deal?.deal_name}</div>
        </div>
        <div className={st.textSt}>
          <div className={st.copitalText}>{translate?.date_of_creation}:</div>
          <div className={st.information}>
            {formatClientDate(deal.created_at)}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ClientDuplicateCard
